import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsKudoNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M23.654 10.655a2.883 2.883 0 00-.8-2.15 3.128 3.128 0 00-2.259-.968H15.2l.743-2.966A3.7 3.7 0 0012.471.325H11.8l-1.109 4.328-2.94 5.67-7.084 3.769 3.792 9.859 6.619-3.526H18.6a3.249 3.249 0 003.223-3l.136-1.892a2.966 2.966 0 001.1-3.251 2.93 2.93 0 00.595-1.627zm-21.3 4.068l3.42-1.82 2.818 7.317-3.42 1.821-2.818-7.318zm19.458-3.062l-.36.344.222.446c.105.214.16.45.159.689a1.624 1.624 0 01-.851 1.419l-.322.177-.184 2.593a1.871 1.871 0 01-1.876 1.746h-7.858l-.949.506-2.816-7.317 1.78-.947 3.169-6.111.906-3.474a2.343 2.343 0 011.8 2.279c0 .096-.004.192-.014.288l-1.153 4.59h7.127a1.763 1.763 0 011.275.546 1.549 1.549 0 01.438 1.151 1.59 1.59 0 01-.491 1.075h-.002z"
        fill=""
      />
    </svg>
  )
);
SvgActionsKudoNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgActionsKudoNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsKudoNormalSmall;
